/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartSchema } from "./banquetCartSchema.ts";
import { banquetComboSchema } from "./banquetComboSchema.ts";
import { banquetOrderItemSchema } from "./banquetOrderItemSchema.ts";
import { blankEnumSchema } from "./blankEnumSchema.ts";
import { cancelReasonEnumSchema } from "./cancelReasonEnumSchema.ts";
import { reserveSectionShortSchema } from "./reserveSectionShortSchema.ts";
import { reserveStatusEnumSchema } from "./reserveStatusEnumSchema.ts";
import { reserveTableSchema } from "./reserveTableSchema.ts";

export const reserveSchema = z.object({
	id: z.uuid(),
	status: reserveStatusEnumSchema
		.optional()
		.describe(
			"* `waiting_creation` - Ожидает создания в iiko\n* `waiting_prepayment` - Ожидает предоплаты\n* `new` - Забронирован\n* `started` - Гости пришли\n* `cancelling` - Отменяется\n* `closed` - Завершён\n* `cancelled` - Отменён\n* `failed` - Ошибка создания",
		),
	table: reserveTableSchema.nullable(),
	section: reserveSectionShortSchema.nullable(),
	start_time: z.iso.datetime(),
	duration_minutes: z.int().min(0).max(2147483647),
	guests_count: z.int().min(0).max(32767),
	customer_name: z.string().max(255),
	phone: z.string().max(20),
	comment: z.string().optional(),
	is_banquet: z.boolean().optional(),
	items: z.array(banquetOrderItemSchema),
	combos: z.array(banquetComboSchema),
	cart: banquetCartSchema.nullable().describe("Состав банкета в формате корзины заказа: тело для замены состава как есть."),
	total_cost: z.number().nullable(),
	pos_total_cost: z.number().nullable(),
	paid_amount: z.number(),
	amount_due: z.number().nullable(),
	prepayment_required: z.number().nullable(),
	prepayment_deadline: z.iso.datetime().nullable(),
	cancel_reason: z.union([cancelReasonEnumSchema, blankEnumSchema]).optional(),
	created_at: z.iso.datetime(),
});
